<template>
    <div>
        <template v-if="edicao && edicao.materiais">
            <az-sub-title title="OPMEs"></az-sub-title>
            <template v-for="(opme, iox) in edicao.materiais">
                <div  :key="'opme' + iox" v-show="opme.fl_ativo" v-if="true">
                    <div class="form-row">
                        <div v-if="opme.id_material" class="col col-12 col-md-6">
                            <az-input
                                sizing="sm"
                                :edicao="false"
                                v-if="opme.material"
                                v-model="opme.material.search">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div v-else-if="opme.id_taxa" class="col col-12 col-md-6">
                            <az-input
                                sizing="sm"
                                :edicao="false"
                                v-if="opme.taxa"
                                v-model="opme.taxa.search">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div v-else-if="opme.id_medicamento" class="col col-12 col-md-6">
                            <az-input
                                v-if="opme.medicamento"
                                sizing="sm"
                                :edicao="false"
                                v-model="opme.medicamento.search">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <template v-else>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="opme.st_descricao">
                                    <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="opme.fl_ativo = false">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input
                                    sizing="sm"
                                    placeholder="Código..."
                                    v-model="opme.st_codigo" />
                            </div>
                        </template>
                        <div class="col col-12 col-md-1">
                            <az-input
                                sizing="sm"
                                type="number"
                                v-model="opme.in_quantidade" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                sizing="sm"
                                placeholder="Fabricante..."
                                v-model="opme.st_fabricante" />
                        </div>
                        <div class="col col-12 col-md-1">
                            <az-input
                                sizing="sm"
                                type="select"
                                :optionsList="lista_status_autorizacao"
                                optionsData="id"
                                optionsDisplay="search"
                                required
                                :validate="validate"
                                v-model="opme.in_status" />
                        </div>
                    </div>
                </div>
            </template>
            
            <az-input
                class="mb-3"
                sizing="sm"
                icon="fas fa-cart-plus fa-fw"
                buttonToolTip="Incluir OPME..."
                type="autocomplete"
                optionsMode="aql"
                optionsName="consumo.index"
                :optionsExternal="true"
                service="consumo.index"
                :optionsParm="{ bt: true }"
                optionsParm2="{ id_operadora: dados.plano.operadora.id_operadora }"
                :optionsSync="true"
                placeholder="Incluir OPME..."
                v-model="novoOpme"
                @input="incluirOpme()"  />
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            novoOpme: null,
        }
    },

    components: {
        AzInput,
        AzSubTitle, 
    },

    computed: { 
        lista_status_autorizacao: function () { 
            return [
                { id: 0, search: 'Aberto' },
                { id: 6, search: 'Enviado' },
                { id: 1, search: 'Autorizado' },
                { id: 9, search: 'On-line' },
                { id: 2, search: 'Em análise' },
                { id: 3, search: 'Negado' },
                { id: 4, search: 'Aut. Parcial' },
                { id: 5, search: 'Cancelado' },
                { id: 10, search: 'Em Sessão' },
                { id: 11, search: 'Pendente' },
                { id: 12, search: 'Particular' },
            ];
        },
    },

    props: ['edicao'], 

    methods: { 
        incluirOpme () {
            if ( !this.novoOpme )
                return;

            if(typeof this.novoOpme == 'string') {
                this.novoOpme = {
                    st_material: this.novoOpme,
                    search: this.novoOpme,
                    st_descricao: this.novoOpme,
                    st_codigo: ''
                }
            }

            let novo = _.cloneDeep(this.novoOpme);
            this.novoOpme = "";

            this.edicao.materiais.push({
                id_solicitacao_autorizacao_material: null,
                id_material: novo.id_material,
                id_medicamento: novo.id_medicamento,
                id_taxa: novo.id_taxa, 
                fl_ativo: true,
                in_quantidade: 1,
                st_fabricante: "",
                st_descricao: novo.st_descricao,
                st_codigo: novo.st_codigo,
                material: novo,
                medicamento: novo, 
                taxa: novo, 
            });

            this.$nextTick(() => {
                this.novoOpme = null;
            });
        },
    }
}
</script>
